

<template>
	<section
		class="flex flex-col sm:justify-between items-center sm:flex-row mt-12 sm:mt-10"
	>
	
		<!-- Banner right illustration -->
		<div data-aos="fade-right" data-aos-duration="1500" class="w-full md:w-2/3 text-right float-right">
			<img
				v-if="theme === 'light'"
				class="w-[710px]"
				src="@/assets/images/meBg.png"
				alt="Developer"
			/>
			<img
				v-else
				class="w-[700px]"
				src="@/assets/images/meBg-dark.png"
				alt="Developer"
			/>
		</div>

		<!-- Banner left contents -->
		<div class="w-full md:w-1/3 text-left mt-10 sm:mt-0">
			<h1
			data-aos="fade-up" data-aos-duration="1500"
				class="font-general-semibold text-3xl md:text-[2.5rem] xl:text-[3rem] text-center sm:text-left text-ternary-dark dark:text-primary-light uppercase"
			>
				Hi, I am Wilson
			</h1>
			<p data-aos="fade-up" data-aos-duration="1500"
				class="font-general-medium mt-2 text-lg sm:text-xl  xl:text-2xl text-center sm:text-left leading-none text-gray-400"
			>
				A Full-Stack Developer
			</p>
			<!-- <p data-aos="fade-up" data-aos-delay="200" data-aos-duration="1800" class="font-general-regular text-ternary-dark dark:text-ternary-light text-[18px] mt-3 text-center sm:text-left">
			I'm full stack developer with 2 years of experience in the industry. I have a passion for building innovative web applications and creating seamless user experiences. My skills include proficiency in PHP, JavaScript, Vue, Laravel, as well as expertise in database design, API development, and testing.
			</p> -->
		
			<div data-aos="fade-up" data-aos-delay="300" data-aos-duration="1800" class="flex justify-center sm:block">
				<a
					
					download="resume_wilson_t_magaoay.pdf"
					href="/files/resume_wilson_t_magaoay.pdf"
					class="flex justify-center items-center w-36 sm:w-48 mt-12 mb-6 sm:mb-0 text-lg border border-indigo-200 
					dark:border-ternary-dark py-2.5 sm:py-3 shadow-lg rounded-lg bg-btnColor focus:ring-1 focus:ring-indigo-900 
					hover:bg-indigo-500 text-white hover:text-white duration-500"
					aria-label="Download Resume"
				>
					<i
						data-feather="arrow-down-circle"
						class="ml-0 sm:ml-1 mr-2 sm:mr-3 w-5 sm:w-6 duration-100"
					></i>
					<span
						class="text-sm sm:text-lg font-general-medium duration-100"
						>Download CV</span
					></a
				>
			</div>
		</div>

	</section>
</template>
<script>
import feather from 'feather-icons';

export default {
	name: 'Home',
	data: () => {
		return {
			theme: '',
		};
	},
	created() {
		this.theme = localStorage.getItem('theme') || 'light';
	},
	mounted() {
		feather.replace();
		this.theme = localStorage.getItem('theme') || 'light';
	},
	updated() {
		feather.replace();
	},
	methods: {},
};
</script>
